// extracted by mini-css-extract-plugin
export default {"cream-on-gold-container":"CreamOnGold_cream-on-gold-container__LgmX7"};